import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    value: null,
};

export const integrationDetails = createSlice({
    name: 'integrationDetails',
    initialState,
    reducers: {
        integrationDetail: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { integrationDetail } = integrationDetails.actions;

export default integrationDetails.reducer;